import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const cache = {};

export default function usePublicContent(kind) {
  const { i18n } = useTranslation();
  const lang = (i18n.language || "it").split("-")[0];
  const [data, setData] = useState(cache[`${kind}-${lang}`] || null);

  useEffect(() => {
    let alive = true;
    const key = `${kind}-${lang}`;
    if (cache[key]) { setData(cache[key]); return; }
    (async () => {
      for (const l of [lang, "it"]) {
        try {
          const res = await fetch(`/content/${kind}/${l}.json`);
          if (!res.ok) continue;
          const json = await res.json();
          cache[key] = json;
          if (alive) setData(json);
          return;
        } catch { /* try fallback */ }
      }
    })();
    return () => { alive = false; };
  }, [kind, lang]);

  return data;
}
